import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Youtube } from 'lucide-react';
import { COMPANY_INFO } from '../config/assets';
import { Separator } from './ui/separator';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { to: '/services', label: 'Polished Concrete' },
    { to: '/services', label: 'Grind and Seal' },
    { to: '/services', label: 'Honed Concrete' },
    { to: '/services', label: 'Floor Prep' }
  ];

  const companyLinks = [
    { to: '/commercial-residential', label: 'Commercial' },
    { to: '/commercial-residential', label: 'Residential' },
    { to: '/portfolio', label: 'Portfolio' },
    { to: '/blog', label: 'Blog' }
  ];

  const resourceLinks = [
    { to: '/aggregate-levels', label: 'Aggregate Levels' },
    { to: '/videos', label: 'YouTube Videos' },
    { to: '/contact', label: 'Get a Quote' },
    { to: '/contact', label: 'Contact Us' }
  ];

  return (
    <footer className="bg-secondary/30 border-t border-border" data-testid="site-footer">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="font-bold text-lg text-foreground">{COMPANY_INFO.name}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {COMPANY_INFO.tagline}
            </p>
            <div className="space-y-2">
              <a
                href={`mailto:${COMPANY_INFO.email}`}
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                data-testid="footer-email-link"
              >
                <Mail className="h-4 w-4" />
                {COMPANY_INFO.email}
              </a>
              <p className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4" />
                {COMPANY_INFO.address}
              </p>
              <a
                href={COMPANY_INFO.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
                data-testid="footer-youtube-link"
              >
                <Youtube className="h-4 w-4" />
                YouTube Channel
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-4">Services</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid={`footer-service-link-${index}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-4">Company</h4>
            <ul className="space-y-2">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid={`footer-company-link-${index}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-4">Resources</h4>
            <ul className="space-y-2">
              {resourceLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    data-testid={`footer-resource-link-${index}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} {COMPANY_INFO.name}. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
